import * as _ from "lodash";

import { types } from "@/actions/map";

const modeInitialState = {
    lights: {},
    deletedLights: [],
    selectedLights: [],
    markers: {},
};

/**
 * Reducer for the mode-scoped light values during editing (select, add, etc.).
 *
 * @param state - The current mode values state.
 * @param root0 - The dispatched action.
 * @param root0.payload - The action payload.
 * @param root0.type - The action type.
 * @returns The next mode values state.
 */
const modeReducer = (state = modeInitialState, { payload, type }) => {
    switch (type) {
        case types.VALUES.MODE.UPDATE_LIGHTS:
        case types.VALUES.MODE.UPDATE_LIGHTS_SILENT:
            _.forIn(payload, (l) => {
                l.changed = true;
            });
            return {
                ...state,
                lights: _.cloneDeep({
                    ...state.lights,
                    ...payload,
                }),
            };
        case types.VALUES.MODE.SET_LIGHTS:
            return {
                ...state,
                lights: _.cloneDeep(
                    payload.reset
                        ? payload.lights
                        : { ...state.lights, ...payload.lights },
                ),
            };
        case types.VALUES.MODE.DELETE_LIGHTS: {
            return {
                ...state,
                deletedLights: [...state.deletedLights, ...payload],
                lights: _.cloneDeep(
                    _.omitBy(state.lights, (light: { uniqueId?: string }) =>
                        _.some(
                            payload,
                            (deletedLight: { uniqueId?: string }) =>
                                deletedLight.uniqueId === light.uniqueId,
                        ),
                    ),
                ),
            };
        }
        case types.GENERAL.CHANGE_MODE:
            return modeInitialState;
        case types.VALUES.MODE.SELECT_LIGHTS: {
            let selectedLights =
                payload.lightsIds.length > 0
                    ? _.xor(state.selectedLights, payload.lightsIds)
                    : payload.lightsIds;
            if (payload.selectionType === "single") {
                selectedLights = _.some(
                    state.selectedLights,
                    (selectedLight) => selectedLight === payload.lightsIds[0],
                )
                    ? []
                    : [payload.lightsIds[0]];
            }
            return {
                ...state,
                selectedLights,
            };
        }
        case types.VALUES.MODE.ADD_TEMPORARY_LIGHT: {
            const selectedLights =
                payload.lightsIds.length > 0
                    ? _.xor(state.selectedLights, payload.lightsIds)
                    : payload.lightsIds;
            _.forIn(payload.lights, (l) => {
                l.changed = true;
            });
            return {
                ...state,
                selectedLights,
                lights: _.cloneDeep({
                    ...state.lights,
                    ...payload.lights,
                }),
            };
        }
        case types.VALUES.MODE.ADD_TEMPORARY_MARKER: {
            _.forIn(payload.markers, (m) => {
                m.changed = true;
            });
            return {
                ...state,
                markers: {
                    ...state.markers,
                    ...payload.markers,
                },
            };
        }
        case types.VALUES.MODE.SET_MARKERS:
            return {
                ...state,
                markers: _.cloneDeep(payload),
            };
        case types.VALUES.MODE.UPDATE_MARKERS: {
            _.forIn(payload, (m) => {
                m.changed = true;
            });
            return {
                ...state,
                markers: {
                    ...state.markers,
                    ...payload,
                },
            };
        }
        default:
            return state;
    }
};

export default modeReducer;
